module.exports = __webpack_public_path__ + "img/hsaStoreSearch.5803664c.png";